/* global axios */
import ApiClient from './ApiClient';

class AiPromptAPI extends ApiClient {
  constructor() {
    super('ai_prompt', { accountScoped: true });
  }

  show() {
    return axios.get(this.url);
  }

  update(data) {
    return axios.patch(this.url, data);
  }
}

export default new AiPromptAPI();
